import Header from "@/components/shared/Header";
import { FormikProvider, useFormik } from "formik";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { toast } from "react-toastify";
import { MultiSelect } from "primereact/multiselect";
import { InputText } from "primereact/inputtext";
import { InputSwitch } from "primereact/inputswitch";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Dropdown } from "primereact/dropdown";
import { INPUT_TYPES } from "@/constants/options";

export default function CreateEditCte() {
  const { state } = useLocation();
  const navigate = useNavigate();

  const isUpdate = state?.id ? true : false;

  const [saveLoading, setSaveLoading] = React.useState<boolean>(false);
  const listwrapper =
    "border-1 border-gray-400 p-4 flex flex-column gap-2 md:gap-3 border-round";

  const userList = [
    {
      name: "Fred Adu",
    },
    {
      name: "John Doe",
    },
    {
      name: "Jane Doe",
    },
    {
      name: "Mary Doe",
    },
  ];

  const [name, setName] = React.useState<any>(state?.name ?? "");
  const [kdes, setKdes] = React.useState<any>(
    state?.kdes ?? [
      {
        label: "",
        placeholder: "",
        type: "",
        helperText: "",
        isRequired: false,
        options: [],
      },
    ]
  );
  const [users, setUsers] = React.useState<any>(state?.users ?? []);

  const formik = useFormik({
    initialValues: {
      name: name,
      users: users,
      kdes: kdes,
    },
    validate: (values) => {
      const errors: any = {};

      if (!values.name) {
        errors.name = "Name of the flow is required";
      }

      return errors;
    },
    enableReinitialize: true,
    onSubmit: (values: any) => {
      if (isUpdate) {
        setSaveLoading(true);
        setTimeout(() => {
          setSaveLoading(false);
          toast.success("Flow updated successfully");
        }, 1000);
      } else {
        setSaveLoading(true);
        setTimeout(() => {
          setSaveLoading(false);
          toast.success("Flow created successfully");
        }, 1000);
      }
    },
  });

  const { values, handleSubmit } = formik;

  console.log(JSON.stringify(values, null, 2));

  return (
    <div>
      <Header
        onBack={() => navigate(-1)}
        title={isUpdate ? "Edit CTE" : "Create CTE"}
        extraAction="Save"
        extraActionIcon="pi pi-save"
        onExtraAction={() => handleSubmit()}
        extraActionLoading={saveLoading}
      />
      <ConfirmDialog />

      <FormikProvider value={formik}>
        <div className="flex flex-column gap-5 p-3 md:p-5">
          <section className={`${listwrapper} md:flex-row`}>
            <div className="w-full md:w-8 flex flex-column  gap-2">
              <label htmlFor="name">Name</label>
              <InputText
                className="w-full"
                placeholder="eg. Name of the flow"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
          </section>

          <section className={`${listwrapper}`}>
            <div className="flex flex-column  gap-2">
              <label htmlFor="users">Assigned Users</label>

              <MultiSelect
                value={users}
                onChange={(e) => setUsers(e.value)}
                options={userList}
                optionLabel="name"
                display="chip"
                placeholder="Select Cities"
                className="w-full md:w-8"
              />
            </div>
          </section>

          <h3 className="my-0">Configure Key Data Elements</h3>

          <span>
            Key Data Elements (KDEs) are the data elements that are required to
            be captured for the CTE.
          </span>

          {/* list of kdes, with delete button */}

          <section className="flex flex-column gap-3">
            {kdes.map((kde: any, index: number) => {
              return (
                <section
                  key={index}
                  className="flex flex-column gap-4 px-5 py-2 border-1 border-gray-400 border-round"
                >
                  {/* // ---------------- HEADER START ---------------- */}
                  <div className="flex flex-row justify-content-between align-items-center">
                    <span>KDE {index + 1}</span>

                    <Button
                      icon="pi pi-trash"
                      className="p-button-danger p-button-text"
                      onClick={() => {
                        confirmDialog({
                          message: "Are you sure you want to delete this KDE?",
                          icon: "pi pi-exclamation-triangle",
                          accept: () => {
                            setKdes((prev: any) => {
                              const newKdes = [...prev];
                              newKdes.splice(index, 1);
                              return newKdes;
                            });
                          },
                          reject: () => {},
                        });
                      }}
                    />
                  </div>
                  {/* // ---------------- HEADER END ---------------- */}

                  {/* ------------------- IS REQUIRED ------------------ */}

                  <section className="flex gap-3 align-items-center">
                    <span>Is this KDE required?</span>

                    <InputSwitch
                      checked={kde.isRequired}
                      onChange={(e) => {
                        setKdes((prev: any) => {
                          const newKdes = [...prev];
                          newKdes[index].isRequired = e.value;
                          return newKdes;
                        });
                      }}
                    />
                  </section>

                  {/* ------------------- IS REQUIRED ------------------ */}

                  {/* // -------------- PLACEHOLDER AND LABEL ---------------- */}
                  <section className="flex flex-column md:flex-row gap-4 ">
                    <div className="w-full md:w-6 flex flex-column gap-2">
                      <label>Label</label>
                      <InputText
                        className="w-full"
                        placeholder="eg. Label for the KDE"
                        value={kde.label}
                        onChange={(e) => {
                          setKdes((prev: any) => {
                            const newKdes = [...prev];
                            newKdes[index].label = e.target.value;
                            return newKdes;
                          });
                        }}
                      />
                    </div>

                    <div className="w-full md:w-6 flex flex-column gap-2">
                      <label>Place Holder</label>
                      <InputText
                        className="w-full"
                        placeholder="eg. Placeholder for the KDE"
                        value={kde.placeholder}
                        onChange={(e) => {
                          setKdes((prev: any) => {
                            const newKdes = [...prev];
                            newKdes[index].placeholder = e.target.value;
                            return newKdes;
                          });
                        }}
                      />
                    </div>
                  </section>
                  {/* // -------------- PLACEHOLDER AND LABEL ---------------- */}

                  {/* // ------------------- TYPE HELPER TEXT ------------------- */}
                  <section className="flex flex-column md:flex-row gap-4 ">
                    <div className="w-full md:w-6 flex flex-column gap-2">
                      <label>Input Type</label>
                      <Dropdown
                        className="w-full"
                        filter
                        placeholder="eg. Label for the KDE"
                        value={kde.type}
                        options={INPUT_TYPES}
                        onChange={(e) => {
                          setKdes((prev: any) => {
                            const newKdes = [...prev];
                            newKdes[index].type = e.target.value;
                            return newKdes;
                          });
                        }}
                      />
                    </div>

                    <div className="w-full md:w-6 flex flex-column gap-2">
                      <label>Help Message</label>
                      <InputText
                        className="w-full"
                        placeholder="eg. Help message for the KDE"
                        value={kde.helperText}
                        onChange={(e) => {
                          setKdes((prev: any) => {
                            const newKdes = [...prev];
                            newKdes[index].helperText = e.target.value;
                            return newKdes;
                          });
                        }}
                      />
                    </div>
                  </section>
                  {/* // ------------------- TYPE HELPER TEXT ------------------- */}
                  {/* ---------------- OPTIONS FOR THE INPUT IF ANY ---------------- */}
                  {/* options input with a remove button and a button to add a new option */}

                  <section className="flex flex-column gap-3">
                    <label>Options</label>

                    {kde?.options?.map((option: any, i: number) => {
                      return (
                        <section
                          key={index}
                          className="flex flex-row justify-content-between align-items-center gap-3"
                        >
                          <InputText
                            className="w-full"
                            placeholder="eg. options for the input type"
                            value={option}
                            onChange={(e) => {
                              setKdes((prev: any) => {
                                const newKdes = [...prev];
                                //  edit the option at the index
                                newKdes[index].options[i] = e.target.value;
                                return newKdes;
                              });
                            }}
                          />

                          <Button
                            icon="pi pi-trash"
                            className="p-button-danger p-button-text"
                            onClick={() => {
                              confirmDialog({
                                message:
                                  "Are you sure you want to delete this option?",
                                icon: "pi pi-exclamation-triangle",
                                accept: () => {
                                  setKdes((prev: any) => {
                                    const newKdes = [...prev];
                                    //  remove the option at the index
                                    newKdes[index].options.splice(i, 1);
                                    return newKdes;
                                  });
                                },
                                reject: () => {},
                              });
                            }}
                          />
                        </section>
                      );
                    })}

                    {/* add new option button */}
                    <section>
                      <Button
                        label={
                          kde.options.length === 0
                            ? "ADD AN OPTION"
                            : "ADD ANOTHER OPTION"
                        }
                        icon="pi pi-plus"
                        className="p-button-sm p-button-outlined mb-3"
                        onClick={() => {
                          setKdes((prev: any) => {
                            const newKdes = [...prev];
                            newKdes[index]?.options?.push("");
                            return newKdes;
                          });
                        }}
                      />
                    </section>
                  </section>

                  {/* ---------------- OPTIONS FOR THE INPUT IF ANY ---------------- */}
                </section>
              );
            })}

            {/* add new kde button */}
            <section>
              <Button
                label={kdes.length === 0 ? "ADD NEW KDE" : "ADD ANOTHER KDE"}
                icon="pi pi-plus"
                className="p-button-success p-button-outlined"
                onClick={() => {
                  setKdes((prev: any) => [
                    ...prev,
                    {
                      label: "",
                      placeholder: "",
                      type: "",
                      helperText: "",
                      isRequired: false,
                      options: [],
                    },
                  ]);
                }}
              />
            </section>
          </section>
        </div>
      </FormikProvider>
    </div>
  );
}
